import { render, staticRenderFns } from "./SafeCenter.vue?vue&type=template&id=391bddb1&scoped=true&"
import script from "./SafeCenter.vue?vue&type=script&lang=js&"
export * from "./SafeCenter.vue?vue&type=script&lang=js&"
import style0 from "./SafeCenter.vue?vue&type=style&index=0&id=391bddb1&lang=scss&module=true&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "391bddb1",
  null
  
)

export default component.exports